export default __webpack_public_path__ + "static/media/LAS0030.34I-30339_-17567_0.240f282a.jpg";